<template>
	<Group
		:state="valid"
		:invalid-feedback="error"
		feedback-beneath
	>
		<div class="d-flex align-items-center">
			<b-select
				v-model="min"
				:options="options"
				class="w-auto d-inline-block"
				@input="emitChangeEvent"
			/>
			<div class="mx-2">bis</div>
			<b-select
				v-model="max"
				:options="options"
				class="w-auto d-inline-block"
				@input="emitChangeEvent"
			/>
			<div class="ml-2">{{ suffix }}</div>
		</div>
	</Group>
</template>

<script>
import Group from "@/vue/common/form/Group.vue";
import {isDefined} from "@/helper/Value";

export default {
	components: {Group},

	props: {
		value: {
			type: Object,
			required: false
		},
		options: {
			type: Array,
			required: true,
		},
		suffix: {
			type: String,
			required: true,
		}
	},

	data ()
	{
		return {
			min: this.value?.min || '',
			max: this.value?.max || '',
		};
	},

	computed: {
		error ()
		{
			if (!this.min || !this.max)
			{
				return 'Bitte triff eine Auswahl';
			}

			if (this.min > this.max)
			{
				return 'Der Mindestwert darf nicht höher als der Maximalwert sein';
			}

			return null;
		},
		valid ()
		{
			return !isDefined(this.error);
		}
	},

	methods: {
		emitChangeEvent ()
		{
			if (!this.valid)
			{
				this.$emit('input', undefined);
				return;
			}

			this.$emit('input', {
				min: this.min,
				max: this.max,
			});
		}
	}
}
</script>
